angular.module('picmonic-common').factory('PresentationsService', [
  '$modal',
  '$interval',
  '$rootScope',
  'MarketOptionsConfig',
  'PresentationsResource',
  'UserService',
  function ($modal, $interval, $rootScope, MarketOptionsConfig, PresentationsResource, UserService) {
    return {
      rsvp: function (pres) {
        var self = this;

        $modal.open({
          templateUrl: pres.missed_it
            ? '/templates/public/modals/presentation-missed-it.html'
            : '/templates/public/modals/presentation-rsvp.html',
          controller: [
            '$rootScope',
            '$scope',
            'UserService',
            '$filter',
            function ($rootScope, $scope, UserService, $filter) {
              $scope.MarketOptionsConfig = MarketOptionsConfig;
              $scope.email = UserService.user.email ? UserService.user.email : '';
              $scope.phone = null;
              $scope.gcal_link =
                'https://www.google.com/calendar/event?action=TEMPLATE' +
                '&dates=' +
                $filter('date')(pres.when * 1000, "yMMddTHHmm00'Z'", '+0000') +
                '%2F' +
                $filter('date')(
                  pres.end_date ? pres.end_date * 1000 : pres.when * 1000 + 3600000,
                  "yMMddTHHmm00'Z'",
                  '+0000'
                ) +
                '&text=Presentation: Study Less, Remember More by Picmonic' +
                '&location=' +
                (pres.meeting_link ? pres.meeting_link : pres.location) +
                '&details=Tips and tricks to help you dominate your classes and exams, and make remembering the impossible, possible.';
              $scope.outlook_link = '/api/v3/presentations/' + pres.presentation_id + '/cal';

              var schedule = moment.tz(pres.when * 1000, pres.timezone);
              pres.start = schedule.tz(moment.tz.guess()).format('llll z');
              $scope.diff = Math.floor(pres.when - Date.now() / 1000);

              pres.presenter_avatar_url = self.getPresenterAvatar(pres);

              interval = $interval(function () {
                $scope.diff--;
              }, 1000);

              $scope.$on('$destroy', function () {
                if (interval) {
                  $interval.cancel(interval);
                }
              });

              $scope.days = function () {
                var days = Math.floor($scope.diff / (60 * 60 * 24));
                if (days < 10) {
                  days = '0' + days;
                }
                return days;
              };

              $scope.hours = function () {
                var hours = Math.floor($scope.diff / (60 * 60)) % 24;
                if (hours < 10) {
                  hours = '0' + hours;
                }
                return hours;
              };

              $scope.minutes = function () {
                var minutes = Math.floor($scope.diff / 60) % 60;
                if (minutes < 10) {
                  minutes = '0' + minutes;
                }
                return minutes;
              };

              $scope.seconds = function () {
                var seconds = Math.floor($scope.diff) % 60;
                if (seconds < 10) {
                  seconds = '0' + seconds;
                }
                return seconds;
              };

              $scope.rsvp = function (email) {
                $scope.error = '';
                if (!$scope.email) {
                  $scope.error = 'Please enter a valid email address.';
                  return;
                }

                if ($scope.phone && $scope.phone.toString().length !== 10) {
                  $scope.error = 'Invalid phone number.';
                  return;
                }

                $scope.email = email;
                $scope.loading = true;

                UserService.setMarketCookies(pres.market_id);

                PresentationsResource.save(
                  { presentation_id: pres.presentation_id, resource: 'rsvps' },
                  { email: email, phone: $scope.phone },
                  function () {
                    if (UserService.user.user_id) {
                      $scope.showThankYou = true;
                    } else {
                      $rootScope.registerModal = {
                        registerTitle: 'Thanks for RSVPing!',
                        email: $scope.email,
                      };
                      UserService.showRegisterModal(
                        false,
                        null,
                        null,
                        'A confirmation email is on its way to your inbox!<br /><a href="' +
                          $scope.gcal_link +
                          '" onclick="atlasEvent(\'click\', \'add-to-gcal\')" target="_blank" class="pls-btn pls-btn--orange pls-white m-t-1" style="min-width: 290px;">ADD TO MY GOOGLE CALENDAR</a><br /><a href="' +
                          $scope.outlook_link +
                          '" onclick="atlasEvent(\'click\', \'add-to-outlook\')" target="_self" class="pls-btn pls-btn--orange  pls-white m-t-1 m-b-1"  style="min-width: 290px;">ADD TO MY OUTLOOK CALENDAR</a><hr /> <strong>Finish creating a free account in 10 seconds:</strong>'
                      );
                      $scope.$close();
                    }

                    $rootScope.$broadcast('presentation.rsvped', {
                      presentation_id: pres.presentation_id,
                    });

                    // Analytics tracking
                    send_ga('event', 'Presentations', 'Registered');
                    var facebookb_tracking = new Image();
                    facebookb_tracking.src = 'https://www.facebook.com/tr?id=759705864106825&ev=Schedule&noscript=1';
                  },
                  function (error) {
                    $scope.loading = false;
                    if (error && error.data && error.data.email) {
                      $scope.error = error.data.email.join(' ');
                    } else if (error && error.data && error.data.phone) {
                      $scope.error = error.data.phone.join(' ');
                    } else if (error && error.data && error.data.message) {
                      $scope.error = error.data.message;
                    } else {
                      $scope.error = 'There was an error with your RSVP.';
                    }
                  }
                );
              };

              $scope.pres = pres;
              if (UserService.user.email) {
                $scope.email = UserService.user.email;
              }
            },
          ],
        });
      },
      getPresenterAvatar: function (preso) {
        var thumb = 'picmonic.png';

        if (!preso.presenter) {
          return (
            ($rootScope.base_asset_url.indexOf('//') === 0 ? 'https:' : '') +
            $rootScope.base_asset_url +
            '/assets/img/presentations/thumbs/' +
            thumb
          );
        }

        switch (preso.presenter.email) {
          case 'Jonny.Antoni@picmonic.com':
            thumb = 'jonny.png';
            break;
          case 'ron.robertson@picmonic.com':
            thumb = 'ron.png';
            break;
          case 'ken.robertson@picmonic.com':
            thumb = 'kenny.png';
            break;
          case 'ibbad.yousuf@picmonic.com':
            thumb = 'ibbad.png';
            break;
          case 'jonathan.crosby@picmonic.com':
            thumb = 'crosby.png';
            break;
          case 'sara.eason@picmonic.com':
            thumb = 'sara.png';
            break;
          case 'nick.tantillo@picmonic.com':
            thumb = 'nicky.png';
            break;
          case 'marlee.liberman@picmonic.com':
            thumb = 'marlee.png';
            break;
          case 'tene.redman@picmonic.com':
            thumb = 'tene.png';
            break;
          case 'thomas.berry@picmonic.com':
            thumb = 'thomas.png';
            break;
          case 'lucas@picmonic.com':
            thumb = 'lucas.png';
            break;
          default:
            thumb = 'picmonic.png';
            break;
        }

        return (
          ($rootScope.base_asset_url.indexOf('//') === 0 ? 'https:' : '') +
          $rootScope.base_asset_url +
          '/assets/img/presentations/thumbs/' +
          thumb
        );
      },
    };
  },
]);
